export default {
    routes: [{
        path: '/roles',
        component: () => import('../pages/roles/Index.vue'),
        name: 'roles.index',
        meta: {
            name: 'Roles',
            title: window.titlePrefix,
            permissions: ['roles.view']
        }
    }, {
        path: '/roles/create',
        component: () => import('../pages/roles/Edit.vue'),
        name: 'roles.create',
        meta: {
            title: window.titlePrefix,
            name: 'Roles',
            permissions: ['roles.create']
        }
    }, {
        path: '/roles/edit/:id',
        component: () => import('../pages/roles/Edit.vue'),
        props: true,
        name: 'roles.edit',
        meta: {
            name: 'Roles',
            title: window.titlePrefix,
            permissions: ['roles.edit']
        }
    }]
}